import * as React from "react";

import { InstallationsContext } from "./InstallationProvider";

export const useInstallationsState = () => {
  return React.useContext(InstallationsContext);
};
